import { isEmptyString as l } from "../../../../../../utils/value/string.js";
import { struct as g } from "../../../../../../utils/struct/main.js";
import { enumerable as d, getter as i } from "../../../../../../utils/struct/property.js";
import { EMPTY_ARRAY as T } from "../../../../../../utils/value/constants.js";
import { isNullish as k, isFunction as b } from "../../../../../../utils/value/is.js";
const A = () => {
  let [t, e, a, n] = T;
  const u = () => !!(t && t === n && a), m = () => !!(t && t === a && n);
  let o = null;
  const p = () => {
    u() && (e = t, t = a, c());
  }, v = () => {
    m() && (e = t, t = n, c());
  }, w = (r, s) => {
    const f = t;
    t = e = a = n = void 0, !l(r) && !l(s) && (a = r, n = s, t = f === a || f === n ? f : a, f !== t && c());
  }, N = (r) => {
    k(r) ? o = null : b(r) && o !== (o = r) && c();
  }, c = () => {
    const r = e, s = t;
    e = void 0, o == null || o(
      g({
        from: i(() => r),
        to: i(() => s)
      })
    );
  };
  return g({
    backward: d(p),
    forward: d(v),
    canNavigateBackward: i(u),
    canNavigateForward: i(m),
    currentTransaction: i(() => t),
    onNavigation: { set: N },
    reset: d(w)
  });
};
export {
  A as createDuplexTransactionNavigator,
  A as default
};
